import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'hotjar_config-hotjar_setting_config_limit_exceeded-error';
/**
 * This event is to track if too many settings are being serialized to the Hotjar config.
 */
export function trackHotjarConfigHotjarSettingConfigLimitExceededError(Application_string) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { Application_string },
    });
}
